import { useConfigurationFinishedContext } from "../ConfigurationFinishedPage/ConfigurationFinishedContext";

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import {
  useCsConfiguration,
  useRootCfgObject,
} from "@plansoft-configuration-renderer/framework";

import { iframeId, language } from "@/Router";
import { RegioluxArrowIcon } from "@/icons/RegioluxIcons";
import { useConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurations } from "@/openapi/api-cpq/queries/queries";
import { FloatingLoadingSpinner } from "@/tools/LoadingSpinner";

export function CustomAddToShoppingCartButton(): JSX.Element {
  const { t } = useTranslation();
  const { context } = useCsConfiguration();

  const { setIsConfigurationFinished } = useConfigurationFinishedContext();

  const { mutate: addToCart, isPending } =
    useConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurations();

  const cfgSessionId = window.sessionStorage.getItem("cfgSessionId");
  const userSessionId = window.sessionStorage.getItem("userSessionId");

  const { isComplete } = useRootCfgObject();

  const geolocationId = context?.geolocationId;

  const tooltipTitle = !isComplete
    ? t("regiolux:tooltip.configurationIncomplete")
    : !userSessionId
      ? t("regiolux:tooltip.noUserSessionId")
      : "";

  function addToShoppingCart(): void {
    if (userSessionId && cfgSessionId) {
      addToCart(
        {
          requestBody: {
            userSessionId: userSessionId,
            configurationSessionId: cfgSessionId,
            localeId: language ? language : "de-DE",
            geolocationId: geolocationId,
          },
        },
        {
          onSuccess: () => {
            const postMessage = {
              iframeId: iframeId,
              eventName: "configurationComplete",
            };
            window.parent.postMessage(postMessage, "*");
            setIsConfigurationFinished(true);
          },
        },
      );
    } else {
      //TODO[sh]: Maybe show error message for user
      console.log("No valid sessionIds found");
    }
  }

  return (
    <>
      {isPending && <FloatingLoadingSpinner />}
      <Tooltip title={tooltipTitle}>
        <span>
          <Button
            disabled={!userSessionId || !isComplete}
            sx={{ marginTop: "1rem" }}
            endIcon={
              <RegioluxArrowIcon
                type="short"
                direction="right"
                style={{ fontSize: "0.8rem" }}
              />
            }
            onClick={addToShoppingCart}
          >
            {t("regiolux:addToShoppingCart")}
          </Button>
        </span>
      </Tooltip>
    </>
  );
}
